import { CapturedModal } from "../cluereader/capture/CapturedModal";
import { TowersReader } from "../cluereader/TowersReader";
import { Towers } from "../../cluetheory/Towers";
import { Vector2 } from "../../../lib/math";
import { ScreenRectangle } from "../../../lib/alt1/ScreenRectangle";
import { AbstractPuzzleSolving } from "./AbstractPuzzleSolving";
import { AbstractPuzzleProcess } from "./AbstractPuzzleProcess";
import { deps } from "../../dependencies";
import { util } from "../../../lib/util/util";
import { Alt1Color } from "../../../lib/alt1/Alt1Color";
import { Log } from "../../../lib/util/Log";
var async_init = util.async_init;
var log = Log.log;
import { Alt1OverlayDrawCalls } from "../../../lib/alt1/overlay/Alt1OverlayDrawCalls";
class TowersSolvingProcess extends AbstractPuzzleProcess {
    constructor(parent) {
        super();
        this.parent = parent;
        this.settings = deps().app.settings.settings.solving.puzzles.towers;
        this.isSolved = false;
        this.was_solved_data = Towers.Blocks.empty().rows.map(r => r.map(() => false));
        this.last_successful_read = Date.now();
        this.initialization = async_init(async () => {
            return {
                reader: await TowersReader.instance()
            };
        });
    }
    showSolutionOverlay(reader, currentState, solution, hidden_by_context_menu = null) {
        const geometry = new Alt1OverlayDrawCalls.GeometryBuilder();
        const blocked_area = hidden_by_context_menu
            ? ScreenRectangle.extend(hidden_by_context_menu, { x: 7, y: 11 })
            : null;
        const blocked = (pos) => blocked_area && ScreenRectangle.contains(blocked_area, pos);
        const TR_OVERLAY_OFFSET = { x: 33, y: 10 };
        const TL_OVERLAY_OFFSET = { x: 12, y: 10 };
        let isSolved = true;
        for (let y = 0; y < solution.blocks.rows.length; y++) {
            const row = solution.blocks.rows[y];
            for (let x = 0; x < row.length; x++) {
                const should = solution.blocks.rows[y][x];
                const is = currentState.blocks.rows[y][x] ?? 0;
                const origin = reader.tileOriginScreenCoordinates({ x, y });
                const TR = Vector2.add(origin, TR_OVERLAY_OFFSET);
                const TL = Vector2.add(origin, TL_OVERLAY_OFFSET);
                const difference = (6 + should - is) % 6;
                const correct = should == is;
                isSolved && (isSolved = correct);
                if (correct) {
                    this.was_solved_data[y][x] = true;
                    if (this.settings.show_correct) {
                        if (!blocked(TR)) {
                            /*
                            this.solution_overlay.text(
                              "✓",
                              TR, {
                                color: Alt1Color.fromHex("#41740e"),
                                width: 8
                              }
                            )*/
                            geometry.rectangle({ origin: Vector2.add(origin, { x: -1, y: -1 }), size: Vector2.add(TowersReader.TILE_SIZE, { x: 3, y: 3 }) }, {
                                color: Alt1Color.green,
                                width: 2
                            });
                        }
                    }
                }
                else {
                    if (this.settings.solution_mode == "target" || this.settings.solution_mode == "both") {
                        if (!blocked(TR)) {
                            geometry.text(should.toString(), TR, {
                                color: Alt1Color.fromHex("#C8C8C8"),
                                width: 10
                            });
                        }
                    }
                    if (this.settings.solution_mode == "delta" || this.settings.solution_mode == "both") {
                        const tr_taken = this.settings.solution_mode == "both";
                        const pos = tr_taken ? TL : TR;
                        if (!blocked(pos)) {
                            geometry.text("+" + difference.toString(), pos, {
                                color: Alt1Color.fromHex("#C8C8C8"),
                                width: 10
                            });
                        }
                    }
                    if (this.was_solved_data[y][x] && this.settings.show_overshot) {
                        if (!blocked(TR)) {
                            geometry.rectangle({ origin: Vector2.add(origin, { x: -1, y: -1 }), size: Vector2.add(TowersReader.TILE_SIZE, { x: 3, y: 3 }) }, {
                                color: Alt1Color.red,
                                width: 2
                            });
                        }
                    }
                }
            }
        }
        this.isSolved = isSolved;
        if (isSolved) {
            geometry.text("Solved", Vector2.add(reader.tileOriginScreenCoordinates({ x: 2, y: 2 }), { x: 21, y: 21 }), {
                color: Alt1Color.green,
                width: 20
            });
            const CHECK_RECTANGLE = { origin: { x: 317, y: 243 }, size: { x: 150, y: 25 } };
            geometry.rectangle(ScreenRectangle.subRect(reader.modal.body.screenRectangle(), CHECK_RECTANGLE), {
                color: Alt1Color.green,
                width: 2,
            });
        }
        this.solution_overlay.setGeometry(geometry.buffer());
    }
    area() {
        return this.parent.lockbox.reader.modal.body.screenRectangle();
    }
    tick(capt) {
        try {
            if (!this.initialization.isInitialized())
                return;
            if (!capt)
                return;
            const capture = CapturedModal.assumeBody(capt);
            const reader = new TowersReader.CapturedTowers(capture, this.initialization.get().reader);
            const puzzle = reader.getPuzzle();
            const context_menu_area = reader.findContextMenu();
            if (puzzle) {
                if (this.puzzle && context_menu_area)
                    puzzle.blocks = Towers.Blocks.combine(puzzle.blocks, this.puzzle.blocks);
                this.puzzle = puzzle;
            }
            if (this.puzzle) {
                const solution = Towers.solve(this.puzzle.hints);
                this.showSolutionOverlay(reader, this.puzzle, solution, context_menu_area);
            }
            if (reader.getState() == "likelyclosed")
                this.puzzleClosed();
        }
        catch (e) {
            if (e instanceof Error) {
                log().log(e.toString());
                log().log(e.stack);
            }
            else {
                console.error(e.toString());
            }
        }
    }
    begin() {
        this.puzzle = this.parent.lockbox.reader.getPuzzle(); // This should already be cached
        super.begin();
    }
}
export class TowersSolving extends AbstractPuzzleSolving {
    constructor(parent, lockbox) {
        super("Towers", parent, lockbox, deps().app.settings.settings.solving.puzzles.towers.autostart, "Towers Puzzle", "towers");
        this.lockbox = lockbox;
    }
    begin() {
        super.begin();
        this.modal.setImage(this.lockbox.reader.puzzle_area.getData());
    }
    constructProcess() {
        return new TowersSolvingProcess(this);
    }
    pausesClueReader() {
        return this.process && !this.process.isSolved;
    }
}
(function (TowersSolving) {
    let Settings;
    (function (Settings) {
        Settings.DEFAULT = {
            autostart: true,
            solution_mode: "delta",
            show_correct: true,
            show_overshot: true,
        };
        function normalize(settings) {
            if (!settings)
                return Settings.DEFAULT;
            if (![true, false].includes(settings.autostart))
                settings.autostart = Settings.DEFAULT.autostart;
            if (!["target", "delta", "both"].includes(settings.solution_mode))
                settings.solution_mode = Settings.DEFAULT.solution_mode;
            if (![true, false].includes(settings.show_correct))
                settings.show_correct = Settings.DEFAULT.show_correct;
            if (![true, false].includes(settings.show_overshot))
                settings.show_overshot = Settings.DEFAULT.show_overshot;
            return settings;
        }
        Settings.normalize = normalize;
    })(Settings = TowersSolving.Settings || (TowersSolving.Settings = {}));
})(TowersSolving || (TowersSolving = {}));
